import { Spec } from '../core/proto/common.js';
import { t } from '../core/i18n/index.js';

import * as InputHelpers from '../core/components/input_helpers.js';

// Configuration for spec-specific UI elements on the settings tab.
// These don't need to be in a separate file but it keeps things cleaner.

export const StartingRage = InputHelpers.makeSpecOptionsNumberInput<Spec.SpecFeralTankDruid>({
	fieldName: 'startingRage',
	label: t('warrior.startingRage'),
	labelTooltip: t('warrior.startingRageTooltip'),
});

export const FeralTankDruidRotationConfig = {
	inputs: [
		InputHelpers.makeRotationNumberInput<Spec.SpecFeralTankDruid>({
			fieldName: 'maulRageThreshold',
			label: t('druid.maulRageThreshold'),
			labelTooltip: t('druid.maulRageThresholdTooltip'),
		}),
		InputHelpers.makeRotationNumberInput<Spec.SpecFeralTankDruid>({
			fieldName: 'lacerateTime',
			label: t('druid.lacerateRefreshLeeway'),
			labelTooltip: t('druid.lacerateRefreshLeewayTooltip'),
		}),
		InputHelpers.makeRotationBooleanInput<Spec.SpecFeralTankDruid>({
			fieldName: 'maintainDemoralizingRoar',
			label: t('druid.maintainDemoRoar'),
			labelTooltip: t('druid.maintainDemoRoarTooltip'),
		}),
	],
};
